<template>
  <div>
    <div class="content_page7">
      <div class="left_page1">
        <div class="brand_title">FINALISEZ LA COMMANDE</div>
      
      <p class="zoom-in">Règlement et partage de l'addition ✅
        <br>
        <br>
        Choisissez la méthode de paiement qui vous convient le mieux ✅
        <br>
        <br>
        Notification de paiement réussi instantanée ✅
        <br>
        <br>
        Transmition des tickets de caisse dématérialisés ✅ 
      </p>
      </div>
      <div class="right_page1">
        <div ref="animationContainer"  style="width: 100%;" ></div>
      </div>
      
    </div>
  </div>
</template>



<script>



import lottie from 'lottie-web'; // Importez la bibliothèque lottie-web

export default {


  name: 'Page_7',
  components: {},


  data: () => ({


  }),

  props: {
    title: String
  },

  mounted() {
    
    // Chargez et affichez l'animation Lottie
    lottie.loadAnimation({
      container: this.$refs.animationContainer, // Référence à l'élément DOM où l'animation sera affichée
      renderer: 'svg', // Vous pouvez également utiliser 'canvas' si vous le préférez
      loop: true, // Spécifie si l'animation doit boucler
      autoplay: true, // Démarre automatiquement l'animation lorsqu'elle est chargée
      path: '/src/animations/pay.json' // Chemin vers votre fichier JSON Lottie
    });
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.content_page7 .brand_title{
  color: #fff;
  width: 100%;
  font-size: 3em;
  animation: content_page7_typing .5s steps(22), content_page7_blink .5s step-end infinite alternate;
  white-space: nowrap;
  overflow: hidden;
  /* border-right: 3px solid; */
  margin-bottom: 6px;
}

.content_page7 .brand_title1{
  color: #fff;
  width: 100%;
  font-size: 3em;
  
  animation: content_page7_typing 1s steps(22), content_page7_blink .5s step-end infinite alternate;
  white-space: nowrap;
  
  overflow: hidden;
  /* border-right: 3px solid; */
  margin-bottom: 6px;
}


.content_page7 p{
  color: #fff;
  font-size: 20px;
  margin: 0px;
  width: 97%;
  margin-top: 24px;
}
.content_page7{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.content_page7 .left_page1,.content_page7 .right_page1{
  flex: 1;
}
.content_page7 .left_page1{
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 8%;
 
}
.content_page7 .right_page1{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  overflow: hidden;
  
}
.content_page7 .brand{
  width: 70%;
  transform: rotate(-20deg);
  position: relative;
  left: 100%;
  animation: content_page7_AnimationBrand 1.5s ease ;
  animation-fill-mode: forwards;
  opacity: 0;
}

@keyframes content_page7_typing {
  from {
    width: 0
    
  }
}
    
@keyframes content_page7_blink {
  50% {
    border-color: transparent
  }
}

@keyframes content_page7_AnimationBrand {
    0%{
      left: 100%;
      transform: rotate(20deg);
      opacity: 0;
    }
    
    100%{
      left: 0%;
      transform: rotate(-20deg);
      opacity: 1;
    }
}

.right_page1 {
  margin-right: 10em;
}

/* Responsive */

@media only screen and (max-width: 600px) {
  .content_page7{
    overflow: hidden;
  }
  .content_page7 .brand_title,.content_page7 .brand_title1{
    font-size: 28px;
    font-weight: bold;
  }
  .content_page7 p{
    font-size: 12px;
  }
  .content_page7 .right_page1{
    overflow: visible;
    
  }
  .content_page7 .brand{
  width: 100%;
  transform: rotate(-20deg);
  position: relative;
  left: 100%;
  animation: content_page7_AnimationBrand 1.5s ease ;
  animation-fill-mode: forwards;
  opacity: 0;
}
}
/* End Responsive  */

.zoom-in {
  font-size: 16px; /* Taille initiale du texte */
  animation: zoomIn 0.9s ease; /* Utilisation de l'animation "zoomIn" pendant 2 secondes */
}

@keyframes zoomIn {
  from {
    font-size: 1px; /* Taille initiale du texte au chargement */
  }
  to {
    font-size: 20px; /* Taille finale du texte après l'animation */
  }
}


</style>
